export default "__VITE_ASSET__DGnjD5e0__";